document.addEventListener('turbo:load', () => {
  const field = document.querySelector('[data-behavior="x-invoice-required"]')

  if (!field) {
    return
  }

  const group = field.closest('.form-group')
  const label = group && group.querySelector('label')
  const radios = document.querySelectorAll('input[type="radio"][name$="[email_invoice_kind]"]')

  if (!label || !radios.length) {
    return
  }

  const buildMark = () => {
    const existing = document.querySelector('.form-group label abbr')

    if (existing) {
      const clone = existing.cloneNode(true)
      clone.title = existing.title || existing.dataset.bsOriginalTitle || 'erforderlich'

      return clone
    }

    const abbr = document.createElement('abbr')
    abbr.title = 'erforderlich'
    abbr.textContent = '*'

    return abbr
  }

  const sync = () => {
    const xInvoice = Array.from(radios).some(radio => radio.checked && radio.value === 'xml')
    const mark = label.querySelector('abbr')

    field.required = xInvoice
    field.setAttribute('aria-required', xInvoice)

    if (xInvoice && !mark) {
      label.append(' ', buildMark())
    } else if (!xInvoice && mark) {
      mark.remove()
    }
  }

  radios.forEach(radio => radio.addEventListener('change', sync))
  sync()
})
